import styled from 'styled-components'
import { TransparentButton } from 'components/common/common_styles'

const PauseButton = props =>
  <TransparentButton {...props}>
    <svg width='48' height='48' viewBox='0 0 48 48' strokeWidth='1.5' strokeLinecap='round' fill='none' stroke='white'>
      <title>Pause</title>
      <Circle cx='24' cy='24' r='23.25' />
      <Line x1='19.75' y1='14.75' x2='19.75' y2='33.25' />
      <Line x1='28.75' y1='14.75' x2='28.75' y2='33.25' />
    </svg>
  </TransparentButton>

export default PauseButton

const Circle = styled.circle`
  svg:hover & {
    fill: white;
  }
`

const Line = styled.line`
  svg:hover & {
    stroke: var(--spBlack);
  }
`
